import { createUseStyles } from 'react-jss';

interface DisplayQueryStyleProps {
  editMode: boolean;
}

const styles = {
  header: {
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.2)',
    '& > div': {
      gridAutoColumns: 'min-content calc(100% - 1rem)'
    }
  },
  headerTitle: {
    fontSize: '200%',
    paddingBottom: '0 !important',
    paddingTop: '0 !important'
  },
  headerFlexBoxGroup: {
    gap: '2rem'
  },
  headerLabel: {
    fontSize: '110% !important',
    color: 'black'
  },
  headerValue: {
    fontSize: '110% !important',
    padding: '0.3rem 0 0.2rem 0.2rem !important',
    color: '#6a6d70 !important'
  },
  objectPage: {
    maxHeight: 'calc(100vh - 2.50rem - 0.25rem)',
    '& > header > div': {
      minHeight: 'unset'
    },
    '& [data-component-name="ObjectPageTabContainer"]': {
      visibility: 'hidden',
      marginBottom: 'calc(2.50rem * -1 - 0.25rem)'
    },
    '& [data-component-name="ObjectPageContent"]': {
      background: 'white',
      height: (props: DisplayQueryStyleProps) =>
        props.editMode
          ? 'calc(85.5vh - 2.75rem - 3rem - 0.25rem)'
          : 'calc(85.5vh - 2.75rem - 0.25rem)'
    },
    '& [data-component-name="ObjectPageSectionContent"]': {
      height: (props: DisplayQueryStyleProps) =>
        props.editMode ? `calc(100% )` : 'calc(100% - 3rem)'
    },
    '& [data-component-name="ObjectPageFooterSpacer"]': {
      height: (props: DisplayQueryStyleProps) => !props.editMode && '0rem !important'
    }
  },
  objectPageSection: {
    height: '100%',
    '& > div:nth-child(2)': {
      height: '100%'
    }
  },
  objectPageContentWrapper: {
    height: '100%'
  },
  formContainer: {
    marginTop: '0.7rem'
  },
  formItemText: {
    alignSelf: 'center',
    flexGrow: '1',
    paddingBottom: '0.8rem',
    whiteSpace: 'pre-wrap'
  },
  formItemLabel: {
    paddingBottom: '0.8rem',
    alignSelf: 'start'
  },
  formItemLabelContainer: {
    width: '100%',
    display: 'block',
    textAlign: 'left'
  },
  mainDivLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingRight: '1rem',
    height: `calc(100%)`,
    overflow: 'auto'
  },
  mainDivRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingLeft: '1rem',
    height: `calc(100%)`,
    overflow: 'auto'
  },
  actionGroup: {
    justifyContent: 'flex-end'
  },
  actionGroupItem: {
    margin: '0.2rem'
  },
  formLineInput: {
    width: '100%',
    '& input': {
      flexGrow: 1
    }
  },
  notificationButton: {
    marginLeft: '0.5rem'
  },
  infoDataFlexBox: {
    width: '100%',
    maxWith: '100%',
    display: 'block !important',
    alignItems: 'start'
  },
  formComponent: {
    alignItems: 'start !important'
  },
  formSwitchLabel: {
    paddingBottom: '0.8rem',
    paddingTop: '0.2rem'
  },
  documentNumberInputContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'DisplayQuery'
});
